import { signInWithCustomToken } from 'firebase/auth';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { auth } from '~/firebase/init';

export default function LineLogin() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const handleLogin = async (token: string) => {
    const callbackUrlParams = searchParams.get('callbackUrl');
    const res = await signInWithCustomToken(auth, token);
    console.log('user', res.user);
    const [callbackUrl, prevLocation = '/'] = callbackUrlParams?.split('+') || [];
    if (callbackUrl) {
      navigate(callbackUrl, { state: { previous: prevLocation } });
    } else {
      navigate('/');
    }
  };
  useEffect(() => {
    if (!searchParams.has('token')) {
      navigate('/');
      return;
    }
    handleLogin(searchParams.get('token')?.toString() || '');
  }, [searchParams]);
  return <></>;
}
